<div class="h-100">
  <div class="p-3 bg-white shadow-sm rounded d-flex flex-column h-100">
    <div class="d-flex justify-content-between">
      <h6 class="line-2">
        {{ request.workshop.title }}
      </h6>
    </div>
    <div class="mt-3">
      <ng-icon name="lucideUser" class="me-2 text-secondary"></ng-icon>
      <span class="align-self-center"
        >{{ "trainingHist.labels.teacher" | translate }}:
        {{ request.workshop.teacherFullName }}</span
      >
    </div>
    <div class="mt-2 d-flex">
      <ng-icon name="lucideCalendar" class="me-2 text-secondary"></ng-icon>
      <span class="align-self-center"
        >{{ "trainingHist.labels.eventDate" | translate }}:
        {{ request.workshop.holdingDateJalali }}</span
      >
    </div>
    <div class="mt-2">
      <ng-icon name="lucideLayers" class="me-2 text-secondary"></ng-icon>
      <span class="align-self-center"
        >{{ "trainingHist.labels.method" | translate }}:
        {{ request.workshop.holdingTypeTitle }}</span
      >
    </div>
    <div class="mt-2">
      <span>{{ "trainingHist.labels.requestDate" | translate }} : </span>
      <span class="align-self-center">{{
        request.registrationDateJalali
      }}</span>
    </div>
    <div class="mt-2">
      <ng-container [ngSwitch]="request.status">
        <span
          *ngSwitchCase="1"
          class="badge bg-warning rounded-pill text-light"
        >
          {{ "trainingHist.labels.pending" | translate }}
        </span>
        <span
          *ngSwitchCase="2"
          class="badge bg-success rounded-pill text-light"
        >
          {{ "trainingHist.labels.approved" | translate }}
        </span>
        <span *ngSwitchCase="3" class="badge bg-danger rounded-pill text-light">
          {{ "trainingHist.labels.rejected" | translate }}
        </span>
        <span
          *ngSwitchCase="4"
          class="badge bg-secondary rounded-pill text-light"
        >
          {{ "trainingHist.labels.expired" | translate }}
        </span>
      </ng-container>
    </div>
  </div>
</div>
